<template>
<div class="login-wrap">
  <div class="form">

    <div class="title">
      <h2>LOGIN TO VOTE</h2>
    </div>

    <div class="field">
        <label for="email">Email</label>
        <input v-validate="'required'" v-model="auth.username" type="email" name="email" id="email" placeholder="Your email address">
        <span>{{ errors.first('email') }}</span>
    </div>
    <div class="field">
        <label for="password">Password</label>
        <input v-validate="'required'" v-model="auth.password" type="password" name="password" id="password" placeholder="Your password">
        <span>{{ errors.first('name') }}</span>
    </div>
    <div class="field">
        <button class="button" @click="login">Login</button>
    </div>

    <div class="form">
      <div class="fields-wrap">
        <div class="field">
          <button class="button grey" @click="$emit('loginType', 'register')">Register</button>
        </div>
        <div class="field">
          <button class="button grey" @click="$emit('loginType', 'forgot')">Forgot Password</button>
        </div>
      </div>
    </div>

    <p class="http-error" v-if="error" >
      <i v-for="(err, index) in error" :key="index">{{ err[0] }}</i>
    </p>

  </div>
</div>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      auth: {
        grant_type: 'password',
        client_id: 2,
        client_secret: 'dywb2hhMgxpFcdCVhXHgOGsRWhdFzfTcDiHpLZl0',
        username: null,
        password: null
      },
      error: null
    }
  },
  mounted () {
  },
  methods: {
    login () {
      this.$store.state.isLoading = true
      this.$http.login(this.auth)
        .then((res) => {
          console.log('then login', res)
          if (res.status !== undefined) {
            console.log('logged-in')
          } else {
            this.error = res.response.data.message
          }
        })
        .then((res) => {
          this.$store.state.isLoading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../scss/variables.scss";
.login-wrap {
  padding: 0;
}
</style>
